import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

import FloatingLoginCard from '../../common-components/FloatingLoginCard';
import AppName from '../../common-components/AppName';
import FlexOne from '../../common-components/FlexOne';
import AlertDialog from '../../common-components/AlertDialog';

import * as strings from '../../helpers/strings';

import * as resetPasswordReducer from '../reducer';
import * as systemReducer from '../../system/reducer';

import * as resetPasswordActionMgr from '../action-mgr';
import * as systemAction from '../../system/action-creator';

import { loginBackground } from '../../helpers/constants';

class ResetPassword extends Component {

  constructor() {
    super();

    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleConfirmPasswordChange = this.handleConfirmPasswordChange.bind(this);
    this.handleConfirmPasswordBlur = this.handleConfirmPasswordBlur.bind(this);
    this.handlePasswordReset = this.handlePasswordReset.bind(this);
    this.handleAlertClose = this.handleAlertClose.bind(this);

    this.validatePassword = this.validatePassword.bind(this);

    this.state = {
      error: false,
      errorMessage: ""
    }
  }

  componentDidMount = () => {
    const { match, setCredentials, setAlertMessage } = this.props;
    const credentials = atob(match.params.credentials).split(":");
    if (credentials.length === 2 && credentials[0] && credentials[1]) {
      setCredentials(credentials[0], credentials[1]);
    } else {
      setAlertMessage(strings.msgIncorrectCredential);
    }

    // Set the background image when the component mounts
    document.body.style.backgroundImage = `url("${loginBackground}")`;
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundRepeat = 'no-repeat';
    document.body.style.backgroundAttachment = 'fixed';
  }
  componentWillUnmount() {
    // Remove the background image when the component unmounts
    document.body.style.backgroundImage = 'none';
    document.body.style.backgroundSize = 'initial';
  }

  handlePasswordChange = e => this.props.setPassword(e.target.value)

  handleConfirmPasswordChange = e => this.props.setConfirmPassword(e.target.value);

  handleConfirmPasswordBlur = () => {
    const { password, confirmPassword, matchPassword } = this.props;
    if (password && confirmPassword)
      matchPassword(password, confirmPassword);
  }

  handlePasswordReset() {

    const { email, otp, password, resetPassword, confirmPassword } = this.props;

    this.setState({
      errorMessage: "",
      error: false
    })

    console.log({
      validate: this.validatePassword(),
      validate_2: (password === confirmPassword)
    })

    if (this.validatePassword() && (password === confirmPassword)) {
      resetPassword(email, otp, password);
    }

  }

  handleAlertClose = () => {
    const { isResetSuccess, toggleAlertDialog, resetSuccessFlag, history } = this.props;
    toggleAlertDialog();

    if (isResetSuccess) {
      resetSuccessFlag();
      history.push("/login");
    }
  }


  validatePassword() {
    const { password, confirmPassword } = this.props

    if (password.search(/[A-Z]/gm) < 0) {
      this.setState({
        errorMessage: "Your password must contain at least one number, one capital character and one special character.",
        error: true
      })
      return false;
    } else if (password.search(/[0-9]/gm) < 0) {
      this.setState({
        errorMessage: "Your password must contain at least one number, one capital character and one special character.",
        error: true
      })
      return false;
    } else if (password.search(/[!@#$%^&*()_+]/gm) < 0) {
      this.setState({
        errorMessage: "Your password must contain at least one number, one capital character and one special character.",
        error: true
      })
      return false;
    } else {
      return true;
    }

  }

  render() {
    const { password, passwordError, confirmPassword, confirmPasswordError, isResettingPassword, alertMessage, openDialog } = this.props;

    return (
      <FloatingLoginCard
        heading={<AppName />}
        subheading={strings.lblEnterNewPassword2Reset}
        secondaryActions={[]}
        isLoading={isResettingPassword}>
        <TextField
          fullWidth={true}
          label={strings.lblPassword}
          onChange={this.handlePasswordChange}
          value={password}
          margin="normal"
          // helperText={(this.state.error) ? this.state.errorMessage : passwordError}
          helperText={this.state.errorMessage}
          error={(this.state.error) ? true : false}
          type="password"
        />
        <TextField
          fullWidth={true}
          label={strings.lblConfirmPassword}
          onChange={this.handleConfirmPasswordChange}
          onBlur={this.handleConfirmPasswordBlur}
          value={confirmPassword}
          margin="normal"
          helperText={confirmPasswordError}
          error={!!confirmPasswordError}
          type="password"
        />
        <Grid container alignItems="center">
          <FlexOne />
          <Button variant={strings.btnRaised} color={strings.colorPrimary} onClick={this.handlePasswordReset} >{strings.lblReset}</Button>
        </Grid>
        <AlertDialog title={strings.lblResetPassword} message={alertMessage} open={openDialog} onClose={this.handleAlertClose} />
      </FloatingLoginCard>
    );
  }
}

const mapStateToProps = state => ({
  email: resetPasswordReducer.getEmail(state),
  otp: resetPasswordReducer.getOTP(state),
  password: resetPasswordReducer.getPassword(state),
  passwordError: resetPasswordReducer.getPasswordError(state),
  confirmPassword: resetPasswordReducer.getConfirmPassword(state),
  confirmPasswordError: resetPasswordReducer.getConfirmPasswordError(state),
  alertMessage: resetPasswordReducer.getAlertMessage(state),
  openDialog: resetPasswordReducer.getOpenDialog(state),
  isValid: resetPasswordReducer.getIsValid(state),
  isResetSuccess: resetPasswordReducer.getIsResetSuccess(state),
  isResettingPassword: systemReducer.getIsResettingPassword(state),
});

const mapActionsToFuncs = {
  resetPassword: systemAction.resetPassword,
  ...resetPasswordActionMgr
};

export default connect(mapStateToProps, mapActionsToFuncs)(
  ResetPassword
);